import { VenuePreset } from '@/domain/project-venue-presets/entities/project-venue-presets.entity';
import { ProjectVenuePresetsGateway } from '@/domain/project-venue-presets/gateways/project-venue-presets.gateway';

import { ORGANISATION_FAKE_ID } from './api-organisation-fake.gateway';
import { FIRST_FAKE_PROJECT_VENUE_ID } from './api-project-venue-fake.gateway';

export class ApiProjectVenuePresetsFakeGateway implements ProjectVenuePresetsGateway {
  async getAll(_projectId: number): Promise<VenuePreset[]> {
    return FAKE_PRESETS;
  }

  async create(preset: VenuePreset): Promise<void> {
    FAKE_PRESETS.push(preset);
  }

  async update(preset: VenuePreset): Promise<void> {
    const index = FAKE_PRESETS.findIndex((x) => x.id === preset.id);
    FAKE_PRESETS[index] = preset;
  }
}

export const FAKE_PRESETS: VenuePreset[] = [
  {
    id: 1,
    organisationId: ORGANISATION_FAKE_ID,
    order: 1,
    projectId: FIRST_FAKE_PROJECT_VENUE_ID,
    presetTitle: 'preset one',
    avgCapacity: 4000,
    mobility: [{ type: 'COACH', percentage: 100, distance: 1000 }],
    accommodation: [
      { type: 'HOTEL', percentage: 40 },
      { type: 'CAMPING', percentage: 60 },
    ],
    equipment: [{ type: 'PROJECTORS', quantity: 10 }],
  },
  {
    id: 2,
    organisationId: ORGANISATION_FAKE_ID,
    order: 2,
    projectId: FIRST_FAKE_PROJECT_VENUE_ID,
    presetTitle: 'preset two - empty',
    avgCapacity: 100,
    mobility: [],
    accommodation: [],
    equipment: [],
  },
];
